import styled, { css, keyframes } from 'styled-components'
import {
  calculateResponsiveSize,
  mediaMax
} from '@dboxdev/ui-components'
import {
  SPLASH_SHEEN_DELAY,
  SPLASH_SHEEN_DURATION,
  SPLASH_EASE_IN_OUT
} from 'styles/splash-timing'
import LogoMono from 'icons/logo.svg'
import LogoUmber from 'icons/logo-umber.svg'

export const RATIO = 112 / 50

const box = css`
  display: block;
  width: ${({ $width }) => calculateResponsiveSize($width)};
  height: ${({ $width }) => calculateResponsiveSize($width / RATIO)};
  ${({ $mobileWidth }) => $mobileWidth && css`
    ${mediaMax('mobile')} {
      width: ${calculateResponsiveSize($mobileWidth)};
      height: ${calculateResponsiveSize($mobileWidth / RATIO)};
    }
  `};
`

export const Mono = styled.span`
  ${box};
  background-color: currentColor;
  mask: url(${LogoMono}) no-repeat center / contain;
  -webkit-mask: url(${LogoMono}) no-repeat center / contain;
`

export const ChromeWrap = styled.span`
  ${box};
  position: relative;
`

const chromeLayer = css`
  position: absolute;
  inset: 0;
`

export const ChromeMono = styled.span`
  ${chromeLayer};
  background-color: var(--chrome-color);
  mask: url(${LogoMono}) no-repeat center / contain;
  -webkit-mask: url(${LogoMono}) no-repeat center / contain;
  opacity: var(--chrome-dark, 0);
  ${mediaMax('mobile')} {
    opacity: 0;
  }
`

export const ChromeRich = styled.img`
  ${chromeLayer};
  width: 100%;
  height: 100%;
  opacity: calc(1 - var(--chrome-dark, 0));
  ${mediaMax('mobile')} {
    opacity: var(--chrome-dark, 0);
    :root:not([data-deck]) & {
      opacity: 1;
    }
  }
`

export const LOGO_UMBER_SRC = LogoUmber

export const GoldWrap = styled.span`
  ${box};
  position: relative;
  isolation: isolate;
`

export const Gold = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`

export const Sheen = styled.span`
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  mix-blend-mode: screen;
  mask: url(${LogoMono}) no-repeat center / contain;
  -webkit-mask: url(${LogoMono}) no-repeat center / contain;
`

const sweep = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(267%);
  }
`

export const SheenBand = styled.span`
  position: absolute;
  top: -30%;
  left: -60%;
  width: 60%;
  height: 160%;
  background: linear-gradient(
    79deg,
    rgba(225, 211, 184, 0) 0%,
    rgba(225, 211, 184, 0.12) 26%,
    rgba(225, 211, 184, 0.42) 48%,
    rgba(225, 211, 184, 0.12) 74%,
    rgba(225, 211, 184, 0) 100%
  );
  will-change: transform;
  animation: ${sweep} ${SPLASH_SHEEN_DURATION}s ${SPLASH_EASE_IN_OUT} ${SPLASH_SHEEN_DELAY}s both;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0;
  }
`
